export { default } from "./ViewPageBanner";
